module.exports = __webpack_public_path__ + "static/media/rig.b422fc84.jpg";